import { formatCurrency, formatNumber } from "../../../../services/format";
import { initListView, ListView } from "../../../UI/view/list-view";
import { liquidMonthlyStatsDS } from "./liquid-billing-datasource";

export const invoiceListStats = {

  columns: [
    {
      id: 'month',
      Header: 'Month',
      accessor: (row) => row.month,
    },
    {
      id: 'year',
      Header: 'Year',
      accessor: (row) => row.year,
    },
    {
      id: 'volume',
      Header: 'Volume',
      accessor: (row) => formatNumber(row.volume),
    },
    {
      id: 'dollars',
      Header: 'Dollars',
      accessor: (row) => formatCurrency(row.dollars),
    },
  ]
} as ListView;

export const InvoiceListStats = initListView(invoiceListStats, liquidMonthlyStatsDS);